<template>
  <div>
    <div class="e-sign-banner pricing-background background">
      <!-- <img src="../assets/img/pricing_gradient.png"> -->
    </div>
    <section class="pricing">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-9 col-centered">
            <p style="color:white;font-size:2em">超级签点数购买</p>
            <div class="row ipricing-row">
              <div class="col-sm-12 col-md-4 col-lg-4 pricing-col" style="border: none;"
                v-for="goods,index in superSignGoodsList">
                <h3 style="color:#9b9b9b">NO.{{index+1}}</h3>
                <div>
                  <span>￥</span>
                  <h4>{{goods.price/100}}</h4>
                  <span class="month-suffix"></span>
                </div>
                <p style>
                  充值：
                  <span style="color:#f87828;">{{goods.payNum}}</span>次
                </p>
                <p style="color:#ff7e3f;" v-if="goods.giveNum>0">赠送：{{goods.giveNum}}次</p>
                <div class="signup-div">
                  <a @click="buy(goods.id)" href="#">
                    <button class="btn btn-outline-primary">购买</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <DownloadOrderDetail v-if="showOrderDetail" :payOrder="payOrder" v-on:closeOrderDetail="closeOrderDetail" />
  </div>
</template>

<script>
var self;
import DownloadOrderDetail from "./DownloadOrderDetail";
import VipOrderDetail from "./VipOrderDetail";
export default {
  name: "HelloWorld",
  components: {
    DownloadOrderDetail,
    VipOrderDetail
  },
  mounted() {
    self = this;
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/goods", {
        type: 1,
        authToken: this.getToken()
      })
      .then(response => {
        this.respDataHandle(response.body, function(data) {
          self.superSignGoodsList = data;
        });
      });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      goodsList: [],
      superSignGoodsList: [],
      account: null,
      payOrder: null,
      showOrderDetail: false,
      showVipOrderDetail: false
    };
  },
  methods: {
    buy: function(goodsId) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/goods/order/" + goodsId, {
          authToken: this.getToken()
        })
        .then(response => {
          this.respDataHandle(response.body, function(data) {
            console.log("tag", data);
            self.payOrder = data;
            self.showOrderDetail = true;
          });
        });
    },
    vip_buy: function(goodsId) {
      this.$http
        .post(
          this._Global.HTTP_SERVER +
            "/auth/order/vip/" +
            goodsId +
            "?authToken=" +
            this.getToken()
        )
        .then(response => {
          this.respDataHandle(response.body, function(data) {
            console.log("tag", data);
            self.payOrder = data;
            self.showVipOrderDetail = true;
          });
        });
    },
    closeOrderDetail: function() {
      this.showOrderDetail = false;
    },
    closeVipOrderDetail: function() {
      this.showVipOrderDetail = false;
    }
  }
};
</script>

<style scoped>
button {
  border-radius: 5em;
}

.pricing-middle {
  border-left: 1px solid #afafaf;
  border-right: 1px solid #afafaf;
}

.ipricing-row {
  margin-top: 65px;
  margin-bottom: 52px;
  /*border: 1px solid #0043FF;*/
  border-radius: 16px;
  background-color: white;
}

p {
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SuperSignPricing.vue